import React, { useEffect, useState } from 'react';
import { Col, Input, Label, Row } from 'reactstrap';
import { toast } from "react-toastify";
import Select from "react-select";
import _ from "lodash";
import { DesktopContainer } from '../layouts';
import { api, constants, dateHelpers, filterHelpers } from '../utils';
import { FilterSelect, LabelSwitch, SpinnerButton } from './';

export default function DevTest() {
   const ALL_SITES = { value: "", label: "-- Select --" };
   const CRITERIA = {
      Id: 1247,
      PrinterId: 0,
      PrintToPrinter: false,
      Name: "" // Printer name if possible
   };
   const [filters, setFilters] = useState([
      { filterName: "siteId", value: ALL_SITES }
   ]);
   const orderId = 'SO-61221';   // used in printCoA function
   const shipId = '19929';       // used in testing UPS labels
   const showBinBtn = false;     // test bin label printing
   const showCoABtn = false;     // test CoA Notifications
   const showGetZBtn = true;    // test finding of z-value for confidence level calculations
   const showUpsBtn = false;     // test UPS label printing
   const showUserBtn = false;    // test user label printing
   const [downloading, setDownloading] = useState(false);
   const [loaded, setLoaded] = useState(false);
   const [printers, setPrinters] = useState([]);
   const [printToPrinter, setPrintToPrinter] = useState(true);
   const [selectedPrinter, setSelectedPrinter] = useState(null);
   const [sites, setSites] = useState([]);
   const [siteId, setSiteId] = useState("");
   const [testString, setTestString] = useState(""); // was used to test building a SQL string and showing the result
   const [zLevel, setZLevel] = useState(95);
   const zLevelMin = 1;
   const zLevelMax = 100;

   useEffect(() => {
      getPrinters();
      getSites();
      testToastr();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   function formatPrinters(data) {
      let printerArr = _.concat(data.labels, data.lasers, data.parts); // Do we need laser printers?
      let list = _.map(printerArr, (x) => {
         return { label: x.nameOnly, value: x.id };
      });
      return list.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : ((b.label.toLowerCase() > a.label.toLowerCase()) ? -1 : 0));
   }

   function getPrinters() {
      api
         .fetch("Printer/GetPrintersForDropdown")
         .then((response) => {
            if (response) {
               setPrinters(formatPrinters(response.data));
            } else {
               toast.error("Failed to get printers.");
            }
         })
         .catch(api.catchHandler);
   }

   function getSites() {
      api
         .fetch(`Reference/LoadSites`)
         .then(response => {
            if (response.data.success) {
               const siteList = _.concat([ALL_SITES],
                  _.map(response.data.sites, m => ({ value: m.value, label: m.label })));
               return { siteList: siteList };
            }
            else {
               toast.error(response.data.message);
            }
         }).then(async ({ siteList, typeList }) => {
            setSites(siteList);
         })
         .catch((error) => {
            api.catchHandler(error);
         })
         .finally(() => {
            setLoaded(true);
         });
   }

   function getZValue() {
      setDownloading(true);
      api
         .fetch(`Reference/GetConfidenceIntervalZValue/${zLevel}`)
         .then(response => {
            if (response.data.success)
               toast.success(`Z-value for ${zLevel} percent is ${response.data.z}`);
            else
               toast.error(response.data.message);
         })
         .catch((error) => {
            api.catchHandler(error);
         })
         .finally(() => {
            setDownloading(false);
         });
   }

   function handleZValChange(value) {
      let intVal = parseInt(value, 10);
      if (isNaN(intVal)) {
         setZLevel(95); // Reset to default if not a number
      } else {
         // Clamp to range
         if (intVal < zLevelMin) intVal = zLevelMin;
         if (intVal > zLevelMax) intVal = zLevelMax;
         setZLevel(intVal);
      }
   }

   function onSiteChange(newFilterValue) {
      setSiteId(newFilterValue.value);
      const site = _.find(sites, x => x.value === newFilterValue.value);
      let newFilters = filterHelpers.getFilters(filters, ({ filterName: "siteId", value: site }));
      setFilters(newFilters);
   }

   function printBinLabel() {
      // This was used for testing bin label printing
      if (!siteId || siteId === "") {
         toast.error("A site must be selected");
         return;
      }

      if (printToPrinter) {
         if (!selectedPrinter || selectedPrinter.value === 0) {
            toast.error("A printer must be selected");
            return;
         }

         setDownloading(true);
         api
            .post("Report/RunBinLabelRpt", {
               Bin: "Test Bin 12345",
               PrinterId: selectedPrinter.value,
               PrinterName: selectedPrinter.label,
               PrintPdf: false,
               SiteId: siteId
            })
            .then((response) => {
               if (response.data.success) {
                  toast.success("Bin Label printed successfully");
               } else {
                  if (_.isString(response?.data?.message)) {
                     toast.error(response?.data?.message);
                  }
               }
            })
            .catch(() => toast.error("There was a failure printing the label"))
            .finally(() => {
               setDownloading(false);
            });
      }
      else {
         setDownloading(true);
         api
            .postDownloadBinary("Report/RunBinLabelRpt", {
               Bin: "Test Bin 12345",
               PrinterId: 0,
               PrinterName: "",
               PrintPdf: true,
               SiteId: siteId
            }, constants.MIME_TYPES.pdf, `Bin_Label.pdf`)
            .then((res) => {
               if (res?.data === false) {
                  toast.error(res.message);
               }
            })
            .catch(api.catchHandler)
            .finally(() => {
               setDownloading(false);
            });
      }
   }

   function printCoA() {
      // This was used for testing CoA email notifications not working
      var url = `Mobile/PrintPackingSlip/${orderId}/${true}`;
      setDownloading(true);
      api
         .postDownloadBinary(url,
            null,
            constants.MIME_TYPES.pdf,
            `PackSlip_${orderId}_${dateHelpers.getDateStringForReportName()}.pdf`
         )
         .then((res) => {
            if (res?.data === false) {
               toast.error(res.message);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
         })
         .finally(() => {
            setDownloading(false);
         });
   }

   function printUpsLabel() {
      var printPdf = !printToPrinter;
      var url = `Mobile/TestUpsLabels/${shipId}/${printPdf}`;
      setDownloading(true);
      if (printPdf) {
         api
            .postDownloadBinary(
               url,
               null,
               constants.MIME_TYPES.pdf,
               `ShipLabel_${dateHelpers.getDateStringForReportName()}.pdf`
            )
            .then((res) => {
               if (res?.data === false) {
                  toast.error(res.message);
               }
            })
            .catch((error) => {
               api.catchHandler(error);
               toast.error(error);
            })
            .finally(() => {
               setLoaded(true);
            });
      }
      else {
         api
            .post(url)
            .then(response => {
               if (response.data.success) {
                  toast.success("Please check the printer for your label(s).");
               }
               else {
                  toast.warning(response.data.message);
               }
            })
            .catch((error) => {
               api.catchHandler(error);
               toast.error(error);
            })
            .finally(() => {
               setLoaded(true);
            });
      }
   }

   function printUserLabel() {
      // This was used for testing user label printing
      var url = `Report/RunUserLabelRpt/`;
      setDownloading(true);
      api
         .postDownloadBinary(url,
            CRITERIA,
            constants.MIME_TYPES.pdf,
            `User_${dateHelpers.getDateStringForReportName()}.pdf`
         )
         .then((res) => {
            if (res?.data === false) {
               toast.error(res.message);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
         })
         .finally(() => {
            setDownloading(false);
         });
   }

   function testToastr() {
      let warnings = [];
      warnings.push('This is a test\n');
      warnings.push('Of a multiline toast\n');
      warnings.push('On the DevTest page\n');
      toast.error(warnings.join(''));
   }

   return (
      <DesktopContainer screenName="Testing In Process">
         <div className="filter-header">
            <Row className="justify-content-center">
               <Col xs={11} className="ps-0 pe-4">
                  <Row className="data-cell">
                     <Col xs="3" style={{ textAlign: "right", marginRight: "5px" }}>
                        <Label>Printers:</Label>
                     </Col>
                     <Col xs="8">
                        <Select
                           classNamePrefix="serviceThreadSelect"
                           options={printers}
                           value={selectedPrinter}
                           onChange={(e) => setSelectedPrinter(e)}
                           isMulti={false}
                           isClearable={false}
                        />
                     </Col>
                  </Row>
               </Col>
            </Row>
         </div>
         <br />
         {showBinBtn && loaded && (
            <div className="filter-header">
               <Row className="justify-content-center">
                  <Col xs={11} className="ps-0 pe-4">
                     <Row className="data-cell">
                        <Col xs={3} className="ps-0 pe-4" style={{ textAlign: "right", marginRight: "5px" }}>
                           <Label>Site:</Label>
                        </Col>
                        <Col xs={8}>
                           <FilterSelect
                              filterName="siteId"
                              options={sites}
                              value={filterHelpers.getValue(filters, "siteId")}
                              onChangeCallback={e => onSiteChange(e)}
                           />
                        </Col>
                     </Row>
                  </Col>
               </Row>
               <Row>
                  <Col className="lineheight15">&nbsp;</Col>
               </Row>
               <Row className="justify-content-center">
                  <Col xs={1} />
                  <Col xs={10} className="ps-0 pe-4">
                     <LabelSwitch
                        displayName="Print to Printer?"
                        buttonLabel="Print Bin LABEL"
                        onChangeCallback={(e) => setPrintToPrinter(e)}
                        onButtonClick={printBinLabel}
                        disabled={downloading}
                     />
                  </Col>
               </Row>
            </div>
         )}
         <br />
         {showUpsBtn && (
            <div className="filter-header">
               <Row className="justify-content-center">
                  <Col xs={1} />
                  <Col xs={10} className="ps-0 pe-4">
                     <LabelSwitch
                        displayName="Print to Printer?"
                        buttonLabel="Print UPS Labels"
                        onChangeCallback={(e) => setPrintToPrinter(e)}
                        onButtonClick={printUpsLabel}
                        disabled={downloading}
                     />
                  </Col>
               </Row>
            </div>
         )}
         <br />
         {showCoABtn && (
            <div className="filter-header">
               <Row className="justify-content-center">
                  <Col xs={1} />
                  <Col xs={10} className="ps-0 pe-4">
                     <SpinnerButton className="shredButton btn-md" onClick={printCoA} on={downloading} disabled={downloading}>
                        Test Print CoA - PDF
                     </SpinnerButton>
                  </Col>
               </Row>
            </div>
         )}
         <br />
         {showUserBtn && (
            <div className="filter-header">
               <Row className="justify-content-center">
                  <Col xs={1} />
                  <Col xs={10} className="ps-0 pe-4">
                     <SpinnerButton className="shredButton btn-md" onClick={printUserLabel} on={downloading} disabled={downloading}>
                        Print User Label - PDF
                     </SpinnerButton>
                  </Col>
               </Row>
            </div>
         )}
         <br />
         {showGetZBtn && (
            <div className="filter-header">
               <Row className="data-cell">
                  <Col xs={3} className="ps-0 pe-4" style={{ textAlign: "right", marginRight: "5px" }}>
                     <Label>Percent Confidence:</Label>
                  </Col>
                  <Col xs={2}>
                     <Input
                        type="number"
                        step={1}
                        value={zLevel || ""}
                        onChange={(e) => handleZValChange(e.target.value)}
                     />
                  </Col>
                  <Col xs={4} className="ps-0 pe-4">
                     <SpinnerButton className="shredButton btn-md" onClick={getZValue} on={downloading} disabled={downloading}>
                        Get Confidence Interval Z-Value
                     </SpinnerButton>
                  </Col>
               </Row>
            </div>
         )}
         <br />
         {testString.length > 0 && (
            <div>
               <pre>{testString}</pre>
            </div>
         )}

      </DesktopContainer >
   );
}
